module.exports = __webpack_public_path__ + "fcf0c82afc3217efc1e328b65c73b42f.svg";